export const roundTo = (value, decimals = 0) => {
  const tenTo = Math.pow(10, decimals);
  return Math.round(value * tenTo) / tenTo;
};
